import { getNumberInfo } from '@lba-dev/package.local-globals/verifyNumber';

import notifSystem from '../notifSystem';

export const cleanPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }
  let cleaned = phoneNumber.replace(/\D/g, '');

  const numberInfo = getNumberInfo(cleaned);
  try {
    if (numberInfo.isValid) {
      return numberInfo.number;
    }
  } catch {
    notifSystem.error('Error', 'Numéro de téléphone invalide');
  }


  if (!cleaned.startsWith('0') && cleaned.length === 9) {
    cleaned = `0${cleaned}`;
  }

  return cleaned;
};
